import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PutVulnerabilityNewLocationInterface {
  objectSlug: string;
  vulnerabilityId: number;
  newLocationData: { x_coord: number; y_coord: number };
}

export const putVulnerabilityNewLocation = async ({
  objectSlug,
  vulnerabilityId,
  newLocationData,
}: PutVulnerabilityNewLocationInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/objects/${objectSlug}/vulnerabilities/${vulnerabilityId}/change-position/`,
    newLocationData,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as any;
};
